import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { MetricsGrid } from '../MetricsGrid';
import { SalesAttribution } from '../Charts/Sales/SalesAttribution/SalesAttribution';
import { RefundsChart } from '../Charts/Sales/RefundsChart';
import { ChargebacksChart } from '../Charts/Sales/ChargebacksChart';
import { ForfeiteDepositsChart } from '../Charts/Sales/ForfeiteDepositsChart';
import { TopSalesServicesTable } from '../Tables/Sales/TopSalesServicesTable';
import { LeaderboardTable } from '../Tables/Sales/LeaderboardTable';
import type { MetricData } from '../../types/DashboardTypes';
import styles from './TabContent.module.scss';

interface SalesTabContentProps {
    metrics: MetricData[];
}

export const SalesTabContent: React.FC<SalesTabContentProps> = ({ metrics }) => {
    const loadingKpiSummary = useSelector((state: RootState) => state.salesDashboard.loadingKpiSummary);
    const loadingAdjustments = useSelector((state: RootState) => state.salesDashboard.loadingAdjustments);
    const adjustments = useSelector((state: RootState) => state.salesDashboard.adjustments);

    return (
        <div className={styles.tabContent}>
            <MetricsGrid
                metrics={metrics}
                isLoading={loadingKpiSummary}
            />
            <div className={styles.chartsSection}>
                <div className={styles.chartContainer}>
                    <SalesAttribution />
                </div>
                <div className={styles.tableContainer}>
                    <TopSalesServicesTable />
                </div>
            </div>
            <div className={styles.analyticsSection}>
                <div className={styles.analyticsRow}>
                    <div className={styles.smallChartContainer}>
                        <RefundsChart
                            data={adjustments?.refunds}
                            isLoading={loadingAdjustments}
                        />
                    </div>
                    <div className={styles.smallChartContainer}>
                        <ChargebacksChart
                            data={adjustments?.chargebacks}
                            isLoading={loadingAdjustments}
                        />
                    </div>
                    <div className={styles.smallChartContainer}>
                        <ForfeiteDepositsChart
                            data={adjustments?.forfeitedDeposits}
                            isLoading={loadingAdjustments}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.leaderboardSection}>
                <LeaderboardTable />
            </div>
        </div>
    );
};
